import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'react-bootstrap';
import { withRouter, Redirect, Switch, Route, Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import TileSettingForm from './TileSettingForm';

// Import Selectors
class FeedbackModulePage extends Component {

  renderInstruction(isAccount = false) {
    return (
      <div className="well well-sm">
        <div>
          <p>
            Modify the information displayed for each {isAccount ? 'account' : 'opportunity'} tile in TruVoice Automation.
          </p>
          <p>
            If you cannot find the field(s) you are looking for, you can also <Link to={`/setup/sync-settings/${isAccount ? 'Account' : 'Opportunity'}`}>add more custom fields to the sync</Link>.
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { location: { pathname } } = this.props;

    return (
      <div>
        <Helmet title="Feedback Module Settings" />
        <div className="container">
          <div>
            <ul className="nav nav-tabs">
              <LinkContainer to={`/setup/feedback-module/opportunity-tiles`}>
                <NavItem>Opportunity Tiles</NavItem>
              </LinkContainer>
              <LinkContainer to={`/setup/feedback-module/account-tiles`}>
                <NavItem>Account Tiles</NavItem>
              </LinkContainer>
            </ul>
            <p />
          </div>
          <Switch>
            <Route
              path={`/setup/feedback-module/opportunity-tiles`}
              render={() => {
                return (
                  <div>
                    <Helmet title="Opportunity Feedback Module Settings" />
                    {this.renderInstruction(false)}
                    <TileSettingForm id="feedback-tile" />
                  </div>
                );
              }}
            />
            <Route
              path={`/setup/feedback-module/account-tiles`}
              render={() => {
                return (
                  <div>
                    <Helmet title="Account Feedback Module Settings" />
                    {this.renderInstruction(true)}
                    <TileSettingForm isAccount id="account-feedback-tile" />
                  </div>
                );
              }}
            />
          </Switch>
          {(pathname === '/setup/feedback-module' && <Redirect to="/setup/feedback-module/opportunity-tiles" />)}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

FeedbackModulePage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

FeedbackModulePage.contextTypes = {
};

export default withRouter(connect(mapStateToProps)(FeedbackModulePage));
